import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export interface FeeCategoryOption {
  id: string;
  name: string;
}

interface FeeCategoryPillSelectProps {
  label: string;
  value: string;
  options: FeeCategoryOption[];
  onChange: (value: string) => void;
  className?: string;
}

export const FeeCategoryPillSelect: React.FC<FeeCategoryPillSelectProps> = ({
  label,
  value,
  options,
  onChange,
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const selectedLabel =
    options.find((option) => option.id === value)?.name || label;

  useEffect(() => {
    const onDocClick = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div ref={rootRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={`flex items-center justify-between gap-2 w-full min-w-[140px] rounded-full border px-4 py-2 text-sm transition-colors ${
          open
            ? 'border-cyan-500 text-cyan-700 bg-white'
            : 'border-cyan-400 text-gray-700 bg-white hover:border-cyan-500'
        }`}
      >
        <span className="truncate">{value ? selectedLabel : label}</span>
        <ChevronDownIcon
          className={`w-4 h-4 shrink-0 text-cyan-600 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="absolute z-20 mt-2 min-w-full w-max max-w-[280px] rounded-lg border border-gray-100 bg-white py-1 shadow-lg">
          <button
            type="button"
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-cyan-50"
            onClick={() => {
              onChange('');
              setOpen(false);
            }}
          >
            Tất cả loại phí
          </button>
          {options.map((option) => (
            <button
              key={option.id}
              type="button"
              className={`block w-full text-left px-4 py-2 text-sm hover:bg-cyan-50 ${
                value === option.id ? 'text-cyan-700 font-medium' : 'text-gray-700'
              }`}
              onClick={() => {
                onChange(option.id);
                setOpen(false);
              }}
            >
              {option.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeeCategoryPillSelect;
